import { render } from "./FilterLoyaltyAttribute.vue?vue&type=template&id=bdecd744"
import script from "./FilterLoyaltyAttribute.vue?vue&type=script&lang=js"
export * from "./FilterLoyaltyAttribute.vue?vue&type=script&lang=js"
script.render = render

export default script